import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { HistoryOutlined, ShopOutlined } from '@ant-design/icons';
import { ReactComponent as KitplayIcon } from '@assets/icons/kitplay.svg';
import { ReactComponent as PiIcon } from '@assets/icons/pi-server.svg';
import ListPage from '@components/common/layout/ListPage';
import PageWrapper from '@components/common/layout/PageWrapper';
import { DEFAULT_FORMAT, DEFAULT_TABLE_ITEM_SIZE, DEVICE_REQUEST_KIND_KITPLAY, DEVICE_REQUEST_KIND_ORDER_DISPLAY, DEVICE_REQUEST_KIND_PI_SERVER, DEVICE_REQUEST_TYPE_DIGIBES, DEVICE_REQUEST_TYPE_PI_SERVER, DeviceKinds } from '@constants';
import apiConfig from '@constants/apiConfig';
import { FieldTypes } from '@constants/formConfig';
import useListBase from '@hooks/useListBase';
import useTranslate from '@hooks/useTranslate';
import { BaseTable } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { convertUtcToLocalTime } from '@utils';

const message = defineMessages({
    objectName: 'Device request',
    piServer: 'Pi server',
    type: 'Type',
});

export const deviceRequestKindOptions = [
    { value: DeviceKinds.DEVICE_TYPE_ORDER_QRCODE, label: commonMessage.ordercon, icon: <PiIcon style={{ fontSize: '18px' }} /> },
    { value: DEVICE_REQUEST_KIND_PI_SERVER, label: commonMessage.piServer, icon: <ShopOutlined style={{ fontSize: '18px' }} /> },
    { value: DEVICE_REQUEST_KIND_KITPLAY, label: commonMessage.kitplay, icon: <KitplayIcon style={{ fontSize: '18px' }} width={18} height={18} /> },
    { value: DEVICE_REQUEST_KIND_ORDER_DISPLAY, label: commonMessage.pickupDisplay, icon: <HistoryOutlined style={{ fontSize: '18px' }} /> },
];

export const deviceRequestTypeOptions = [
    {
        value: DEVICE_REQUEST_TYPE_DIGIBES,
        label: commonMessage.Device,
        icon: <ShopOutlined style={{ fontSize: '16px' }} />,
    },
    {
        value: DEVICE_REQUEST_TYPE_PI_SERVER,
        label: commonMessage.piServer,
        icon: <PiIcon style={{ fontSize: '18px' }} />,
    },
];
// deviceRequestKindOptions
const DeviceRequestListPage = () => {
    const translate = useTranslate();
    const deviceRequestTypeValue = translate.formatKeys(deviceRequestTypeOptions, ['label']);
    const deviceRequestKindValue = translate.formatKeys(deviceRequestKindOptions, ['label']);

    const { data, mixinFuncs, queryFilter, loading, pagination, changePagination } = useListBase({
        apiConfig: apiConfig.deviceRequest,
        options: {
            pageSize: DEFAULT_TABLE_ITEM_SIZE,
            objectName: translate.formatMessage(message.objectName),
        },
        override: (funcs) => {
            funcs.mappingData = (response) => {
                if (response.result === true) {
                    return {
                        data: response.data.content,
                        total: response.data.totalElements,
                    };
                }
            };
        },
    });

    const columns = [
        {
            title: '#',
            dataIndex: 'type',
            width: 60,
            align: 'center',
            render: (type) => {
                const matchedOption = deviceRequestKindOptions.find((item) => item.value === type);

                if (!matchedOption) return null;

                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {matchedOption.icon}
                    </div>
                );
            },
        },
        {
            title: <FormattedMessage defaultMessage="Name" />,
            dataIndex: 'name',
        },
        {
            title: <FormattedMessage defaultMessage="Device ID" />,
            dataIndex: 'deviceId',
            width: 150,
        },
        // {
        //     title: <FormattedMessage defaultMessage="Type" />,
        //     dataIndex: 'type',
        //     width: 150,
        //     render: (type) => {
        //         const typeLabel = deviceRequestTypeValue.find((item) => item.value === type)?.label || '';
        //         return <div>{typeLabel}</div>;
        //     },
        // },
        {
            title: <FormattedMessage defaultMessage="Kind" />,
            dataIndex: 'kind',
            width: 150,
            render: (kind) => {
                const kindLabel = deviceRequestKindValue?.find((item) => item.value === kind)?.label || '';
                return <div>{kindLabel}</div>;
            },
        },
        {
            title: <FormattedMessage defaultMessage="Created date" />,
            dataIndex: 'createdDate',
            width: 200,
            align: 'right',
            render: (createdDate) => {
                const createdDateLocal = convertUtcToLocalTime(createdDate, DEFAULT_FORMAT, DEFAULT_FORMAT);
                return <div>{createdDateLocal}</div>;
            },
        },
    ];

    const searchFields = [
        {
            key: 'deviceId',
            placeholder: translate.formatMessage(commonMessage.deviceId),
            colSpan: 4,
        },
        {
            key: 'type',
            placeholder: translate.formatMessage(message.type),
            type: FieldTypes.SELECT,
            options: deviceRequestTypeValue,
            colSpan: 4,
        },
    ];

    return (
        <PageWrapper routes={[{ breadcrumbName: translate.formatMessage(commonMessage.deviceRequest) }]}>
            <ListPage
                searchForm={mixinFuncs.renderSearchForm({
                    fields: searchFields,
                    initialValues: queryFilter,
                    isReload: true,
                })}
                baseTable={
                    <BaseTable
                        onChange={changePagination}
                        pagination={pagination}
                        loading={loading}
                        dataSource={data}
                        columns={columns}
                        rowKey="id"
                    />
                }
            />
        </PageWrapper>
    );
};

export default DeviceRequestListPage;